import { z } from 'zod'

// RAL-183: the cold-boot screen's phases. `idle` is both ends of the life cycle — before the
// gate elapses and after the exit completes, nothing is in the DOM either way.
export const BootPhaseEnum = z.enum(['idle', 'visible', 'held', 'exiting', 'failed'])
export type BootPhase = z.infer<typeof BootPhaseEnum>
